import { DEFAULT_SITE_CONDITIONS } from '../../domain/foundation/siteConditions';
import type { ThermalInputs } from '../../engines/types';

// Owned by the layer presets built from it; re-exported under the name the
// store, mappers and share hydration already use.
export { DEFAULT_VISIBILITY as DEFAULT_VIS } from '../../components/builder/visibilityPresets';

export const DEFAULT_THERMAL: ThermalInputs = {
  glassAreaSqm: 0,
  stoneAreaSqm: 0,
  isOutdoorLogCabin: false,
  heaterType: 'wood',
  includesShower: false,
};

export { DEFAULT_SITE_CONDITIONS };

/** Auto-save debounce delay in milliseconds */
export const AUTO_SAVE_DELAY_MS = 2000;
